import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { SkipButtonGroup } from '../skip-button-group/component';
import { useSkipWithAnalytics } from '../../../hooks/skin/use-skip';

interface Props {
    className?: string;
    currentFragment: SkippableFragment;
}

export const CompoundCreditSkipButtonGroup: FC<Props> = ({ currentFragment, className }) => {
    const { isSkipEnabled, skip, cancel, onSkipButtonShow } = useSkipWithAnalytics(currentFragment);
    const intl = useIntl();

    if (!isSkipEnabled) {
        return null;
    }

    return (
        <SkipButtonGroup
            cancelButtonText={intl.formatMessage({
                id: 'features.player.show-credits.2356e5f7f801f88158bdbec7b67a1e68',
                defaultMessage: 'View credits',
                description: 'Текст смотреть титры в скине в фиче плеера',
            })}
            onSkipClick={skip}
            onCancelClick={cancel}
            className={className}
            onSkipButtonShow={onSkipButtonShow}
        />
    );
};
